<template>
  <div class="CardMap" :class="$enums.SpaceTypes.STUDIO === space.type ? 'CardMap__studio' : ''" v-if="space" v-show="cardShow">
      <div class="CardMap__top" @click="closeCard">
          <i class="fa fa-minus"></i>
      </div>
      <div  class="CardMap__body">
        <template v-if="$enums.SpaceTypes.STUDIO === space.type">
          <div class="CardMap__title" :class=" !space.url ? 'm-b-0' : ''">
            <div v-if="space.label" class="CardMap__label">
              <p v-html="space.label"></p>
            </div>
            <div v-if="space.number" class="CardMap__number" v-html="space.number"></div>
            <div>
              <span v-if="space.info"
                    v-html="space.info"
                    class="CardMap__name"></span>
              <span v-if="space.price"
                    v-html="space.price"
                    class="CardMap__price "></span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="CardMap__icon" v-if="space.icon" v-html="space.icon"></div>
          <div class="CardMap__title CardMap__lite" :class=" !space.label ? 'CardMap__title-withoutLabel' : ''">
            <div v-if="space.label" class="CardMap__lite-label">
              <p v-html="space.label"></p>
            </div>
            <div>
                <span v-if="space.name"
                      class="CardMap__lite-name"
                      :class=" (space.price || space.description) ? 'm-b-5' : ''"
                      v-html="space.name"></span>
                <span v-if="space.price"
                      v-html="space.price"
                      class="CardMap__lite-price"></span>
                <p v-if="space.description"
                      v-html="space.description"
                      class="CardMap__lite-description"></p>
            </div>
          </div>
        </template>

        <a v-if="space.url && space.label_button" :href="space.url" class="CardMap__action Btn Btn__secondary" >
          <span>{{ space.label_button }}</span>
        </a>
      </div>
  </div>
</template>

<script>
  export default {
    name: 'CardMap',
    props: {
      cardShow: {
        type: Boolean,
      },
      space: {
        type: Object,
      }
    },
    computed: {
      showCard() {
        return this.space;
      }
    },
    methods: {
      closeCard() {
        this.$emit('closeCard');
      }
    }
  }
</script>